import { COMPLETED, LOADING, ERROR, BROKER_PRODUCTS, BROKER_PRODUCT } from './types';
import { getBrokerProducts, getBrokerProductSummary } from '../../services/integrationResources';

export const getProducts = () => async (dispatch, getState) => {
  const {
    data: { recommendationCode },
  } = getState()['userInfo'];

  dispatch(setBrokerProductsStarted());

  try {
    const result = await getBrokerProducts(recommendationCode);

    dispatch(setBrokerProductsSuccess(result));
  } catch (error) {
    setBrokerProductsFailure(error.message);
  }
};

const setBrokerProductsSuccess = (payload) => ({
  type: `${BROKER_PRODUCTS}_${COMPLETED}`,
  payload: payload,
});

const setBrokerProductsStarted = () => ({
  type: `${BROKER_PRODUCTS}_${LOADING}`,
});

const setBrokerProductsFailure = (error) => ({
  type: `${BROKER_PRODUCTS}_${ERROR}`,
  payload: {
    error,
  },
});

export const getProduct = (product) => async (dispatch, getState) => {
  const {
    data: { recommendationCode },
  } = getState()['userInfo'];

  dispatch(setBrokerProductStarted());

  try {
    const result = await getBrokerProductSummary(recommendationCode, product);

    dispatch(setBrokerProductsuccess(result));
  } catch (error) {
    setBrokerProductFailure(error.message);
  }
};

export const setBrokerProductsuccess = (payload) => ({
  type: `${BROKER_PRODUCT}_${COMPLETED}`,
  payload: payload,
});

const setBrokerProductStarted = () => ({
  type: `${BROKER_PRODUCT}_${LOADING}`,
});

const setBrokerProductFailure = (error) => ({
  type: `${BROKER_PRODUCT}_${ERROR}`,
  payload: {
    error,
  },
});
